import { render, staticRenderFns } from "./FinancialDetail.vue?vue&type=template&id=22bee403&scoped=true"
import script from "./FinancialDetail.vue?vue&type=script&lang=js"
export * from "./FinancialDetail.vue?vue&type=script&lang=js"
import style0 from "./FinancialDetail.vue?vue&type=style&index=0&id=22bee403&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bee403",
  null
  
)

export default component.exports